/**
 * English mirror of ./strings.ar.js — GENERATED by scripts/i18n/build.mjs.
 *
 * Wording follows the legacy Locale/*.resx English resources wherever the
 * legacy screen had the same label. To change any of it, edit
 * scripts/i18n/strings.en.json and re-run the script.
 */

export const categoriesStrings = {
  actionFailed: 'The operation could not be completed',
  imported: 'Topic imported successfully',
  deleteFailed: 'The operation could not be completed',
  title: 'Manage Chapters',
  subtitle: 'Add New Category or Edit Existing One.',

  actions: {
    create: 'New Category',
    upload: 'Upload Category',
  },

  filter: {
    publicity: 'Publicity',
    all: 'All',
    public: 'Public',
    private: 'Private',
  },

  stats: {
    caption: 'Topics at a glance',
    total: 'Total topics',
    chapters: 'Total chapters',
    questions: 'Total questions',
    minutes: 'Content minutes',
  },

  columns: {
    index: 'ID',
    name: 'Arabic Name',
    arabicLength: 'Arabic Chapter Length in Minutes',
    nameEn: 'English Name',
    englishLength: 'English Chapter Length in Minutes',
    chapters: 'Chapters Count',
    questions: 'Questions Count',
    createdOn: 'Creation Date',
    publicity: 'Publicity',
  },

  row: {
    edit: 'Update',
    chapterFiles: 'Chapter files',
    delete: 'Remove chapter',
    exportTopic: 'Export the topic as a zip file',
    exportQuestions: 'Export the questions to Excel',
  },

  exported: (filename) => `Downloaded: ${filename}`,

  chapterFiles: {
    title: 'Chapter files',
    language: 'Chapter language',
    arabic: 'Arabic',
    english: 'English',
    loading: 'Loading…',
    empty: 'This topic has no chapters',
    missing: 'No video uploaded in this language',
    missingShort: 'Not available',
  },

  form: {
    editTitle: 'Edit Topic',
    saved: 'Operation completed successfully',
    naming: 'Name and description',
    presentation: 'Visibility and image',
    nameAr: 'Arabic Name',
    descriptionAr: 'Arabic Description',
    nameEn: 'English Name',
    descriptionEn: 'English Description',
    publicity: 'Publicity',
    public: 'Public',
    private: 'Private',
    banner: 'Upload Image File',
    save: 'Save',
    required: 'Field required',
  },

  uploadHint: 'Only ZIP Files Accepted!',
  deleteConfirm: 'Do you really want to delete this category?',
  deleted: 'Operation Completed Successfully',
  close: 'Close',
}

export const categoryWizard = {
  steps: {
    topic: 'Topic details',
    chapters: 'Video chapters',
    questions: 'Questions',
  },
  chapters: {
    title: 'Topic chapters',
    add: 'Add a chapter',
    titleAr: 'Chapter title in Arabic',
    titleEn: 'Chapter title in English',
    videoAr: 'Arabic video (mp4)',
    videoEn: 'English video (mp4)',
    empty: 'No chapters added yet',
    remove: 'Remove chapter',
    duration: 'Duration',
    reset: 'Clear the fields',
  },
  questions: {
    title: 'Topic questions',
    add: 'Add a question',
    fromExcel: 'Import from an Excel file',
    empty: 'This topic has no questions yet',
    count: 'questions',
  },
}

export const questionsStrings = {
  deleteFailed: 'The operation could not be completed',
  saved: 'Operation completed successfully',
  imported: 'The questions were imported successfully',
  title: 'Questions List',

  actions: {
    create: 'Add a question',
    excel: 'Questions Excel Upload',
  },

  columns: {
    index: 'ID',
    text: 'Question',
    answer: 'Accepted answer',
    option1: 'Answer 1',
    option2: 'Answer 2',
    option3: 'Answer 3',
    option4: 'Answer 4',
    category: 'Parent Category',
    difficulty: 'Level',
  },

  row: {
    edit: 'Update',
    delete: 'Delete',
  },

  form: {
    optionsPanel: 'Questions Options and Answers',

    options: 'Options',

    questionAr: 'Question text in Arabic',
    questionEn: 'Question text in English',
    optionsAr: 'Arabic options',
    optionsEn: 'English options',
    imageAr: 'Arabic question image',
    imageEn: 'English question image',
    classification: 'Category and answer',
    chosenAnswer: 'Chosen Answer',
    difficulty: 'Difficulty Level',
    category: 'Belongs to this Category',
    question: 'Question',
    required: 'Field required',
    save: 'Save',
  },

  deleteConfirm: 'Delete this question?',

  deleted: 'Operation Completed Successfully',
  close: 'Close',
}

export const certificatesStrings = {
  actionFailed: 'The operation could not be completed',
  saved: 'Operation completed successfully',
  /* The dialog's own title and confirm button. Without them it inherited
     ConfirmDialog's DELETE defaults - see CertificatesPage. */
  cloneTitle: 'Copy template',
  cloneConfirm: 'Create a copy of this template?',
  title: 'Certificate Settings',
  subtitle: 'Add new Templates or edit existing one.',

  actions: {
    create: 'New Template',
  },

  columns: {
    index: 'ID',
    name: 'Arabic Name',
    nameEn: 'English Name',
    uploadedOn: 'Upload Date',
  },

  row: {
    arabicTemplate: 'Arabic Template',
    englishTemplate: 'English Template',
    edit: 'Update',
    clone: 'Clone',
    delete: 'Delete',
  },

  form: {
    info: 'Certificate Templates Information',
    files: 'Certificate Templates files',
    nameAr: 'Arabic Name',
    nameEn: 'English Name',
    prefix: 'Identifier Prefix',
    prefixPlaceholder: 'Prefix Text',
    prefixHint: 'Optional — precedes the certificate number',
    fileAr: 'Upload Arabic Certificate Templates file',
    fileEn: 'Upload English Certificate Templates file',
    fileSpec: 'PNG 1528x1080',
    save: 'Save',
    required: 'Field required',
    lengthError: 'Text must be with in 2 to 300 letters.',
    prefixError: 'Please make sure Prefix is between 1 and 100 characters',
  },

  editor: {
    title: 'Certificate template',
    layers: 'Certificate elements',
    properties: 'Properties',
    artwork: 'Certificate background',
    name: 'Trainee name',
    program: 'Course',
    date: 'Date',
    code: 'Validation Code',
    font: 'Font Type',
    color: 'Font color',
    size: 'Font size',
    style: 'Font Style',
    bold: 'Bold',
    italic: 'Italic',
    center: 'Horizontal center',
    offset: 'offset',
    offsetHint: 'Horizontal offset from the center of the certificate, in pixels.',
    align: 'Text alignment',
    alignStart: 'Right',
    alignCenter: 'Center',
    alignEnd: 'Left',
    show: 'Show element',
    hide: 'Hide element',
    editText: 'Double click to edit the text',
    seed: {
      name: 'Double Click to Edit Name',
      program: 'Double Click to Edit Program',
      date: 'Double Click to Edit Date',
      code: 'Double Click to Edit Cert ID',
    },
    zoomIn: 'Zoom in',
    zoomOut: 'Zoom out',
    zoomFit: 'Fit to screen',
    undo: 'Undo',
    redo: 'Redo',
    reset: 'Reset',
    close: 'Close',
    saved: 'Operation Completed Successfully',
    position: 'Position',
    uploadArtwork: 'Choose a background image',
    noArtwork: 'No image uploaded yet',
  },

  deleteConfirm: 'Delete this template?',

  deleted: 'Operation Completed Successfully',
  close: 'Close',
}
